import { Component } from '@theme/component';

/**
 * WDW Header: ergänzt Horizons <header-drawer> (Öffnen, Schließen, Escape, Fokus-Falle, Scroll-Sperre) um
 * - Fokus auf den ersten Menülink beim Öffnen und zurück auf den Menü-Button beim Schließen
 *   (Animations-Briefing, Abschnitt Mobile-Menü)
 * - data-scrolled am Header ab 24 px Scrolltiefe (Schatten der Sticky-Pill, Styling in Phase 9)
 * - data-compact: große Pill beim Laden und Hochscrollen, kleine beim Runterscrollen
 *
 * Menü und Menü-Button liegen in Horizons <header-drawer> und sind dessen Refs, deshalb per Selektor.
 *
 * @extends {Component}
 */
class WdwHeaderComponent extends Component {
  #controller = new AbortController();

  /** @returns {HTMLDetailsElement | null} */
  get menu() {
    return this.querySelector('details[data-menu]');
  }

  /** @returns {HTMLElement | null} */
  get menuButton() {
    return this.menu?.querySelector('summary') ?? null;
  }

  connectedCallback() {
    super.connectedCallback();
    const { signal } = this.#controller;

    this.menu?.addEventListener('toggle', this.#onToggle, { signal });
    // Horizon scrollt auf Desktop .page-wrapper statt des Fensters, deshalb im Capture auf document lauschen
    document.addEventListener('scroll', this.#onScroll, { passive: true, capture: true, signal });
    this.#onScroll();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller.abort();
  }

  #onToggle = () => {
    if (!this.menu) return;

    if (this.menu.open) {
      const firstLink = this.menu.querySelector('.wdw-menu__link');
      // Nach dem Einfahren fokussieren, damit der Fokus nicht außerhalb des sichtbaren Bereichs landet
      window.setTimeout(() => firstLink?.focus({ preventScroll: true }), 120);
    } else {
      this.menuButton?.focus({ preventScroll: true });
    }
  };

  #lastY = 0;

  /**
   * data-compact: beim Runterscrollen (ab 80 px) kleine Pill, beim Hochscrollen und ganz oben wieder groß.
   * 6 px Toleranz, damit Trackpad-Zittern nicht hin und her schaltet.
   */
  #onScroll = () => {
    const wrapper = document.querySelector('.page-wrapper');
    const y = Math.max(window.scrollY, wrapper ? wrapper.scrollTop : 0, 0);
    this.toggleAttribute('data-scrolled', y > 24);

    const delta = y - this.#lastY;
    if (y <= 80) this.removeAttribute('data-compact');
    else if (delta > 6) this.setAttribute('data-compact', '');
    else if (delta < -6) this.removeAttribute('data-compact');
    else return;

    this.#lastY = y;
  };
}

if (!customElements.get('wdw-header-component')) {
  customElements.define('wdw-header-component', WdwHeaderComponent);
}
